/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react';
import './index.scss';
import { Dropdown } from 'react-bootstrap';
import DarkIcon from 'src/assets/images/language-dark.png';
import LightIcon from 'src/assets/images/language-light.png';
import useHistory from 'src/hooks/useHistory';
import useTheme from 'src/hooks/useTheme';

const languages = {
  en: {
    code: 'en',
    googleCode: 'en',
    title: 'English',
  },
  'pt-br': {
    code: 'pt-br',
    googleCode: 'pt',
    title: 'Português (Brasil)',
  },
  'zh-cn': {
    code: 'zh-cn',
    googleCode: 'zh-CN',
    title: '简体中文',
  },
  'zh-tw': {
    code: 'zh-tw',
    googleCode: 'zh-TW',
    title: '繁体中文',
  },
  ms: {
    code: 'ms',
    googleCode: 'ms',
    title: 'Melayu',
  },
  id: {
    code: 'id',
    googleCode: 'id',
    title: 'Indonesian',
  },
  vi: {
    code: 'vi',
    googleCode: 'vi',
    title: 'Tiếng Việt',
  },
  th: {
    code: 'th',
    googleCode: 'th',
    title: 'ภาษาไทย',
  },
  ta: {
    code: 'ta',
    googleCode: 'ta',
    title: 'தமிழ்',
  },
  tl: {
    code: 'tl',
    googleCode: 'tl',
    title: 'Filipino',
  },
  my: {
    code: 'my',
    googleCode: 'my',
    title: 'မြန်မာ',
  },
  ne: {
    code: 'ne',
    googleCode: 'ne',
    title: 'नेपाली',
  },
  tpi: {
    code: 'tpi',
    googleCode: 'tpi',
    title: 'Tok Pisin tok ples',
  },
  bn: {
    code: 'bn',
    googleCode: 'bn',
    title: 'বাংলা',
  },
};

const LanguageSwitch = () => {
  const { searchParams, updateSearchParams } = useHistory();
  const [lang, setLang] = useState(() => searchParams.get('l') ?? 'en');
  const { theme } = useTheme();
  const isDarkTheme = theme === 'dark';
  const langIcons = isDarkTheme ? DarkIcon : LightIcon;
  const translateTo = useCallback((lang) => {
    const code = languages[lang].googleCode;
    const googTransValue = `/en/${code}`;
    const rootDomain = location.hostname?.split('.')?.slice(-2)?.join('.');
    document.cookie = `googtrans=${googTransValue};path=/;domain=${location.hostname}`;
    document.cookie = `googtrans=${googTransValue};path=/;domain=.${location.hostname}`;
    document.cookie = `googtrans=${googTransValue};path=/;domain=.${rootDomain}`;
    document.cookie = `googtrans=${googTransValue};path=/`;
    location.reload();
  }, []);

  useEffect(() => {
    if (searchParams.get('l') === lang) return;
    updateSearchParams('l', lang);
    translateTo(lang);
  }, [lang, translateTo, updateSearchParams]);

  return (
    <Dropdown
      className={`language-switch language-switch--${
        isDarkTheme ? 'dark' : 'light'
      } notranslate`}
    >
      <Dropdown.Toggle variant="outline">
        <img className="icon" src={langIcons} />
        <span>{languages[lang].title}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        {Object.values(languages).map((x) => (
          <Dropdown.Item
            key={x.code + x.title}
            href={'#'}
            onClick={() => setLang(x.code)}
            className={x.code === lang ? 'selected' : ''}
          >
            {x.title}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitch;
